/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-29 11:48:40
 * @LastEditors: liuziwei
 * @Description: 订单详情页 - 支持跳打车页的券
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view wx:if="{{displayedInfo.amount}}" class="coupon-item-container">
    <!-- 信息展示部分 -->
    <view class="coupon-info-area">
      <!-- 券优惠信息 -->
      <view class="left-area">
        <view class="amount-area">
          <text wx:if="{{displayedInfo.amount}}" class="amount">{{ displayedInfo.amount }}</text>
          <text wx:if="{{displayedInfo.unit}}" class="unit">{{ displayedInfo.unit }}</text>
        </view>
      </view>
      <!-- 券详情介绍 -->
      <view class="right-area">
        <!-- 券名称 -->
        <text wx:if="{{couponInfo.name}}" class="name">{{ couponInfo.name }}</text>
        <!-- 券介绍结界 -->
        <text wx:if="{{couponInfo.remark}}" class="remark-area">
          <!-- 最高抵消多少钱 -->
          <text wx:if="{{displayedInfo.maxAmount}}">{{ displayedInfo.maxAmount }} </text>
          <!-- 隔离占位符 -->
          <text>{{ '〡' }}</text>
          <!-- 券介绍 -->
          <text wx:if="{{couponInfo.remark}}">{{ couponInfo.remark }}</text>
        </text>
      </view>
    </view>
    <!-- 券状态部分 -->
    <view class="jump-dache-area" bindtap="jumpToDachePage">
      <view class="jump-text">去打车</view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { couponStatusConf } from '@/config/coupon'
  import { jumpToDachePage } from '@/utils'
  import { getCouponDisplayedInfo } from '@/utils/coupon'

  createComponent({
    props: {
      couponData: {
        type: Object,
        value: () => {}
      }
    },
    data: {
      jumpToDachePage
    },
    computed: {
      // 券信息
      couponInfo() {
        return this.couponData?.coupon_info || {}
      },
      // 优惠信息
      displayedInfo() {
        return getCouponDisplayedInfo(this.couponInfo)
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .coupon-item-container
    border-radius 8px
    background #FFF6F1
    height 64px
    border 0.5px solid rgba(255, 0, 0, 0.3)
    display flex
    align-items center
    justify-content space-between
    position relative
    -webkit-mask radial-gradient(circle at calc(100% - 88.5px) 4.5px , transparent 4.5px, #000 0) 0 -4.5px
    mask radial-gradient(circle at calc(100% - 88.5px) 4.5px , transparent 4.5px, #000 0) 0 -4.5px
    &::before, &::after
      content ''
      position absolute
      right 83px
      width 9px
      height 9px
      border-radius 50%
      border 0.5px solid rgba(255, 0, 0, 0.3)
    &::before
      top -5px
    &::after
      bottom -5px
    .coupon-info-area
      height 100%
      display flex
      flex 1
      align-items center
      padding-left 10px
      .left-area
        width 90px
        display flex
        flex-shrink 0
        flex-direction column
        align-items center
        margin-right 4px
        .amount-area
          display flex
          align-items baseline
          justify-content center
          .amount, .unit
            font-weight 600
            color #F86316
          .amount
            font-family Barlow Semi Condensed
            font-size 35px
            line-height 35px
          .unit
            font-family PingFang SC
            font-size 14px
            line-height 15px
      .right-area
        display flex
        flex-direction column
        .name
          font-family PingFang SC
          font-size 15px
          font-weight 600
          line-height 15px
          color #333
          margin-bottom 5.5px
        .remark-area
          font-family PingFangSC-Regular
          font-size 10px
          font-weight normal
          line-height 14px
          color #666
    .jump-dache-area
      width 88px
      height 61px
      display flex
      align-items center
      justify-content center
      border-left 1px dashed rgba(248, 99, 22, 0.3)
      font-family PingFang SC
      font-size 15px
      font-weight 500
      line-height 15px
      box-sizing border-box
      color #F86316
      .jump-text
        font-family PingFangSC-Medium
        font-size 12px
        font-weight normal
        line-height 14px
        color #FF5900
        position relative
        &::after
          content ''
          position absolute
          top 3px
          right -8px
          width 5px
          height 5px
          border-top 1.5px solid #FF5900
          border-right 1.5px solid #FF5900
          transform rotate(45deg)
</style>

<script name='json'>
  module.exports = {
    usingComponents: {}
  }
</script>

